import { http, utils } from "~/utils";
import * as moment from "moment";

export default {
    getID: async cpoNumber => {
        return http.get(`/india/obj/cpo/${cpoNumber}/`).then(response => response.data);
    },
    createOetIn: async (cpo, circle, project, stp_number) => {
        return http
            .post("/india/oet/", {
                customer_purchase_order: cpo,
                circle,
                project,
                stp_number
            })
            .then(response => response.data);
    },
    getOetInDetail: async oet_id => {
        return http.get(`/india/oet/${oet_id}/`).then(response => response.data);
    },
    passToProjectOet: async (oet_id, status) => {
        return await http.put(`/india/oet/${oet_id}/`, { status }).then(response => response.data);
    },
    updateOET: async (oet_id, body) => {
        return await http.put(`/india/oet/${oet_id}/`, body).then(response => response.data);
    },
    updateOrderEntryTemplateItem: async (body) => {
        return await http.put(`/india/oet/update-bypass/`, body).then(response => response.data);
    },
    updateOETItems: async (oet_id, oet) => {
        return await http.put(`/india/oet/${oet_id}/`, { ...oet }).then(response => response.data);
    },
    getOETSites: async (oet_id, run_id, page = null, site_ids = null) => {
        return http
            .get(`/india/site/`, {
                params: {
                    oet: oet_id,
                    ...(run_id ? { run: run_id } : {}),
                    ...(page ? { page } : {}),
                    ...(site_ids ? { site_ids: site_ids } : {})
                }
            })
            .then(response => ({
                list: response.data.results,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    getOETSitesAutoComplete: async (oet_id, run_id, search, search_list = null) => {
        return http
            .get(`/india/site/`, {
                params: {
                    autocomplete: true,
                    page_size: 100,
                    ...(oet_id ? { oet: oet_id }: {}),
                    ...(run_id ? { run: run_id } : {}),
                    ...(search ? { search } : {}),
                    ...(search_list ? { search_list } : {})
                    
                }
            })
            .then(response => response.data.results);
    },
    getAccountIndicators: async (search) => {
        return http.get(`/india/account-indicator/`, {
            params: {
                ...(search ? {search} : {}),
            }
        }).then(response => ({
            list: response.data.results,
            pagination: {
                actual: response.data.actual,
                count: response.data.count,
                next: response.data.next,
                pages: response.data.pages,
                previous: response.data.previous
            }
        }));
    },
    getSSOTIOET: async (
        oet_id,
        run_id,
        page = null,
        cancelled = null,
        only_parent = null,
        site_ids = null,
        material_type = null
    ) => {
        return http
            .get("/india/site_service_order_template_item/", {
                params: {
                    oet: oet_id,
                    ...(cancelled !== null ? { cancelled } : {}),
                    ...(only_parent ? { only_parent: true } : {}),
                    ...(run_id ? { run: run_id } : {}),
                    ...(page ? { page } : {}),
                    ...(site_ids ? { site_ids } : {}),
                    ...(material_type ? { material_type } : {})
                }
            })
            .then(response => ({
                list: response.data.results,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    download: async (run, oet) => {
        return http
            .get(`/india/export_oet/${run.id}/`, {
                responseType: "blob"
            })
            .then(response => {
                if (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    const name = oet.name ? `${oet.name}` : `OET-${oet.id}-RUN-${run.id}`;
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `ZINA_${name}${run.vpo_count !== null ? `_${run.vpo_count}` : ""}_${moment(run.created_at).format(
                            "DD-MM-YYYY"
                        )}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                }
            });
    },
    getRunList: async oetID => {
        return http.get(`/india/run/`, { params: { oet: oetID } }).then(response => response.data.results);
    },
    createRun: async (oet_id, oet_item, type_flow, data) => {
        const headers = {headers: {"content-type": "multipart/form-data"}}
        if (type_flow !== 'non_sode'){
            if(data){
                return http.post(`/india/run/`, data, headers).then(response => response.data);
            }
        }
        data = {
            oet: oet_id,
            oet_item: oet_item,
            type_flow: type_flow,
        }
        return http.post(`/india/run/`, data).then(response => response.data);
    },
    runReport: async filters => {
        return http.post(`/india/export_history/`, filters, { responseType: "blob" }).then(response => {
            const filename = "RunReport.xlsx";
            if (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
            }
        });
    },
    oetDashboardReport: async filters => {
        return http.post(`/india/oet-dashboard-report/`, filters).then(response => {
            return response
        });
    },
    getRunStatuses: function() {
        return http.get("/india/run/statuses/").then(function(response) {
            var data = Array.isArray(response.data) ? response.data : (response.data.results || []);
            return data.map(function(s) {
                return typeof s === "object"
                    ? { value: s.id !== undefined ? s.id : s.value, label: s.name !== undefined ? s.name : s.label }
                    : { value: s, label: s };
            });
        });
    },
    getReportDefault: async (filters) => {
        return http.post(`/india/download-reports-default/`, filters).then(response => {
            return response
        });
    },
    getRunDetail: async run_id => {
        return http.get(`/india/run/${run_id}/`).then(response => response.data);
    },
    updateRun: async (run_id, values) => {
        return await http.patch(`/india/run/${run_id}/`, { ...values }).then(response => response.data);
    },
    syncQuantityContract: async run_id => {
        return http.post(`/india/run/${run_id}/sync-quantity-contract/`).then(response => response.data);
    },
    changeQuantityLimit: async run_id => {
        return http.post(`/india/run/${run_id}/change-quantity-limit/`).then(response => response.data);
    },
    startPRValidation: async (run_id, pr_validation_id) => {
        return http
            .post(`/india/pr-validation/${pr_validation_id}/start-validation/${run_id}/`)
            .then(response => response.data);
    },
    syncWbs: async run_id => {
        return http.post(`/india/run/${run_id}/sync-wbs/`).then(response => response.data);
    },
    syncVoa: async run_id => {
        return http.post(`/india/run/${run_id}/sync-voa/`).then(response => response.data);
    },
    createComment: async data => {
        data = utils.clearObjectNulls(data);
        const formData = new FormData();
        Object.keys(data).map(key => formData.append(key, data[key]));
        return http
            .post("/comments/comment/", formData, {
                headers: { "content-type": "multipart/form-data" }
            })
            .then(response => response.data);
    },
    getComments: async (content_type, object_id) => {
        return http
            .get("/comments/comment/", {
                params: {
                    content_type,
                    object_id
                }
            })
            .then(response => response.data);
    },
    cancelSsotItems: async (run_id, id__in, action) => {
        return http
            .post(`/india/run/${run_id}/cancel-ssot-items/`, {
                id__in,
                action
            })
            .then(response => response.data);
    },
    searchSsotItems: async (run_id, id__in, filter_type = null) => {
        const data = utils.clearObjectNulls({
            id__in: id__in,
            action: "partial_cancel",
            filter_type: filter_type
        });
        return http.post(`/india/run/${run_id}/search-ssot-items-ids/`, data).then(response => response.data);
    },
    requestJob: async (run_id, quantity_contract_number) => {
        return http
            .post(`/contract_management/contract/request-job/`, {
                quantity_contract_number,
                run: run_id
            })
            .then(response => response.data);
    }
};
